/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Service Info 

export const SERVICE_INFO = {
	deposits: {"name": "Deposits", "description": "All deposits related data", "colour": "#2593B0"},
	user_accounts: {"name": "User Accounts", "description": "All user accounts and user data", "colour": "#A5E3DE"},
	payments: {"name": "Payments", "description": "Payments - money in and out", "colour": "#f7d48a"},
	history: {"name": "History", "description": "Accounts, deposits and system", "colour": "#fa8a6c"},
	banking: {"name": "Banking", "description": "Deposify banking backend", "colour": "#458e49"},
	storage: {"name": "Storage", "description": "All uploaded files", "colour": "#6d5849"},
	permissions: {"name": "Permissions", "description": "Resource permissions", "colour": "#a7c8db"},
	messaging: {"name": "Messaging", "description": "Mailboxes and email messaging", "colour": "#7e4917"},
	system_general: {"name": "System General", "description": "System General", "colour": "#00CC99"},
	security: {"name": "Security", "description": "Security backend", "colour": "#5d95ac"},
	events: {"name": "Events", "description": "Events and compliance", "colour": "#55b0f3"},
	frontend: {"name": "Frontend", "description": "All frontend related controls", "colour": "#9FAB0B"},
	search: {"name": "Search", "description": "Search backend", "colour": "#9863de"},
	yardi: {"name": "Yardi", "description": "Yardi", "colour": "#2ca271"},
};
